import { BotbPassDrawerContent } from "./page-content";
import BotbPassDrawerProvider from "./botb-pass-drawer-provider";

const BotbPassDrawer = ({
  shouldShowSubscriptionDrawer,
  overrideDesktopDisplaying = false,
}: {
  shouldShowSubscriptionDrawer: boolean;
  overrideDesktopDisplaying?: boolean;
}) => {
  return (
    <BotbPassDrawerProvider
      shouldShowSubscriptionDrawer={shouldShowSubscriptionDrawer}
      overrideDesktopDisplaying={overrideDesktopDisplaying}>
      <BotbPassDrawerContent />
    </BotbPassDrawerProvider>
  );
};

export default BotbPassDrawer;
